import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { style: { "width": "100%" } };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h1", null, "歌曲管理", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_edit = _resolveComponent("edit");
    const _component_el_icon = _resolveComponent("el-icon");
    const _component_el_button = _resolveComponent("el-button");
    const _component_AddSong = _resolveComponent("AddSong");
    const _component_el_table_column = _resolveComponent("el-table-column");
    const _component_el_table = _resolveComponent("el-table");
    const _component_el_pagination = _resolveComponent("el-pagination");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.showAddSongModal({})), ["stop"]))
        }, {
            default: _withCtx(() => [
                _createVNode(_component_el_icon, { size: 20 }, {
                    default: _withCtx(() => [
                        _createVNode(_component_edit)
                    ]),
                    _: 1
                }),
                _createTextVNode("新增歌曲 ")
            ]),
            _: 1
        }),
        _createVNode(_component_AddSong, {
            ref: "addSongRef",
            onGetAllSongs: _ctx.getAllSongs,
            onUpdateLocalStorage: _ctx.updateLocalStorage
        }, null, 8, ["onGetAllSongs", "onUpdateLocalStorage"]),
        _createVNode(_component_el_table, {
            data: _ctx.songs,
            style: { "width": "100%", "z-index": "0" }
        }, {
            default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "歌曲名"
                }),
                _createVNode(_component_el_table_column, {
                    prop: "author",
                    label: "作者"
                }),
                _createVNode(_component_el_table_column, {
                    fixed: "right",
                    label: "操作"
                }, {
                    default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                            type: "text",
                            size: "small",
                            onClick: ($event) => (_ctx.showAddSongModal(scope.row))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode("修改")
                            ]),
                            _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_button, {
                            type: "text",
                            size: "small",
                            onClick: ($event) => (_ctx.handleDelete(scope.row))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode("删除")
                            ]),
                            _: 2
                        }, 1032, ["onClick"])
                    ]),
                    _: 1
                })
            ]),
            _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_pagination, {
            background: "",
            layout: "prev, pager, next, jumper, total",
            total: _ctx.total,
            "current-page": _ctx.currentPage,
            onCurrentChange: _ctx.currentChange,
            "page-size": _ctx.pageSize
        }, null, 8, ["total", "current-page", "onCurrentChange", "page-size"])
    ]));
}
